const loader = () => {
  const renderButtonLoader = () => {
    return `
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      <span role="status"> Please wait...</span>
    `;
  }

  const renderLoaderOnly = () => {
    return `
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    `;
  }


  const loggingInButtonLoader = () => {
    return `
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      <span role="status"> Logging in...</span>
    `;
  }

  return {
    renderButtonLoader,
    renderLoaderOnly,
    loggingInButtonLoader,
  };
}

export default loader;
